module.exports = __webpack_public_path__ + "static/media/sopor.95d20587.mp3";